<template>
    <div class="message-content">
        <el-tabs :tab-position="tabPosition" @tab-click="handleTabClick" v-model="tabName" type="border-card">
          <!-- 全部类型消息 -->
          <el-tab-pane class="content-total" name="first" label="接收的">
              <UrgeMessageTable 
                ref="dynamicTable1"
                :pageData="pageData"
                :page="page"
                :isShowUpdAllBtn="isShowUpdAllBtn"
                @queryTableData="queryTableData"
                @handleMessageDelete="handleMessageDelete"
                @linkPage="linkPage"
                @handleAllMessageDelete="handleAllMessageDelete"
                @handleAllMessageRead="handleAllMessageRead"
              />
          </el-tab-pane>
          <el-tab-pane class="content-total" name="second" label="发送的">
              <UrgeMessageList 
                v-if="urgeMessageByMe"
                ref="urgeMessageList"
              />
          </el-tab-pane>
        </el-tabs>
        <el-dialog
            title="消息简要"
            append-to-body
            :visible.sync="isShowDetail">
            <el-form  :model="messageInfo" size="mini" label-width="120px" class="message-form">
                <el-form-item label="消息类型:" prop="msgTitle">
                    <el-tag type="danger">催办消息</el-tag>
                </el-form-item>
                <el-form-item label="消息标题:" prop="msgTitle">
                    <!-- <div class="message-item-pre message-item-content">
                        {{messageInfo.msgTitle}}
                    </div> -->
                    <el-input readonly  v-model="messageInfo.msgTitle"></el-input>
                </el-form-item>
                <el-form-item label="消息内容:" prop="msgContent">
                    <!-- <div style="white-space: pre-line;" class="message-item-pre message-item-content">
                        {{messageInfo.msgContent}}
                    </div> -->
                    <el-input readonly type="textarea" style="width:99%" :rows="6"  v-model="messageInfo.msgContent"></el-input>
                </el-form-item>
                <el-form-item v-if="messageInfo.linkedUrl" label="访问详情" prop="linkedUrl">
                    <div style="cursor:pointer;" @click.stop="linkToDetailPage()">
                        <span class="message-item-pre tag-link span-line">点击进入</span>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import { getProcessTaskDetail, getMessageList, updMessage, deleteMessage, updAllMessageStatus, delAllMessage } from '@/data-model';
import mixinsNav from '@/mixins/mixins-nav';
import UrgeMessageTable from './UrgeMessageTable';
import UrgeMessageList from './UrgeMessageList';

export default {
    mixins: [ mixinsNav ],
    // register the component
    components: {
        UrgeMessageTable,
        UrgeMessageList
    },
    data () {
        return {
            urgeMessageForMe: false,
            urgeMessageByMe: false,
            tabName: 'first',
            tabPosition: 'top',
            tableHeight: '460px',
            isShowDetail: false,
            page: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            tableLoading: false,
            pageData: [],
            tableColumns: [
                {
                    id: '1',
                    prop: 'msgTitle',
                    label: '消息标题'
                },
                {
                    id: '2',
                    prop: 'sendTime',
                    label: '产生时间'
                },
                {
                    id: '3',
                    prop: 'msgTypeView',
                    label: '消息类型'
                }
            ],
            searchParams: {
                msgType: 7,
                msgStatus: null // 消息阅读状态 null全部 0未读 1已读
            },
            messageInfo: {
                msgTitle: '',
                msgContent: '',
                linkedUrl: ''
            },
            messageParam: {
                msgflag: 1,
                msgType: 7
            }
        };
    },
    props: {
        // msgType: { // 消息类型
        //     type: Number
        // },
        msgStatus: { // 消息阅读状态
            type: Number
        },
        isShowUpdAllBtn: {
            type: Boolean,
            default: false
        }
    },
    created () {
        this.urgeMessageForMe = true;
        this.initData();
    },
    methods: {
        initData () {
            this.queryTableData(this.page);
        },
        handleTabClick (tab, event) {
            if (tab.name === 'first') {
                this.urgeMessageForMe = true;
                this.urgeMessageByMe = false;
                this.queryTableData(this.page);
            } else if (tab.name === 'second') {
                this.urgeMessageForMe = false;
                this.urgeMessageByMe = true;
            }
        },
        queryTableData ({currentPage}) {
            this.page.currentPage = currentPage;
            this.renderTableList(this.selectedModel);
        },
        async renderTableList () {
            this.tableLoading = true;
            this.searchParams.msgStatus = this.msgStatus;
            let formData = await getMessageList(Object.assign({}, {
                currentPage: this.page.currentPage,
                pageSize: this.page.pageSize
            }, this.searchParams));
            this.pageData = formData.data;
            // console.log(this.isSubform);
            this.page = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
            this.tableLoading = false;
        },
        async handleMessageDelete (row) {
            this.$confirm(`您确定要删除当前消息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                await deleteMessage(row.id);
                await this.queryTableData(this.page);
            }).catch(() => {});
        },
        linkPage (row) {
            updMessage(row);
            // this.navigateTo(row.linkedUrl);
            // this.navMessage(row.id);
            this.messageInfo = row;
            this.isShowDetail = true;
            setTimeout(() => { // 更新navbar上消息红点
                this.$parent.$parent.$children[0].setWarnMessageHot();
            }, 0);
        },
        async linkToDetailPage () {
            if (this.messageInfo.msgTemplateCode === '0710010001') {
                let taskInstanceId = this.messageInfo.linkedUrl;
                // console.log(taskInstanceId);
                let taskInfo = await getProcessTaskDetail(taskInstanceId);
                let processTaskStr = {};
                processTaskStr.processInstanceId = taskInfo.processInstanceId;
                processTaskStr.processInstanceName = taskInfo.processInstanceName;
                processTaskStr.taskInstanceId = taskInstanceId;
                processTaskStr.taskName = taskInfo.name;
                processTaskStr.taskState = taskInfo.taskState;
                let processTaskJson = JSON.stringify(processTaskStr);
                sessionStorage.setItem('navToTaskList', processTaskJson);
                this.navMyTaskMyAssignee();// 我负责
            } else if (this.messageInfo.msgTemplateCode === '0710010002') {
                // let approvalInstanceId = this.messageInfo.linkedUrl;
                // console.log(approvalInstanceId);
                this.navMyApprovalApprove();// 我审批
            }
        },
        async handleAllMessageDelete (msgType) {
            this.$confirm(`您确定要删除所有消息吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                // console.log(msgType);
                this.messageParam.msgType = msgType;
                await delAllMessage(this.messageParam);
                await this.queryTableData(this.page);
            }).catch(() => {});
        },
        async handleAllMessageRead (msgType) {
            this.$confirm(`您确定要所有未读消息标为已读吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async (res) => {
                this.messageParam.msgType = msgType;
                await updAllMessageStatus(this.messageParam);
                await this.queryTableData(this.page);

                setTimeout(() => { // 更新navbar上消息红点
                    this.$parent.$parent.$children[0].setWarnMessageHot();
                }, 0);
            }).catch(() => {});
        }
    }
};
</script>

<style>
  .message-content{
      width: 100%;
  }
  .message-item-pre{
      padding-left: 10px;
      margin-left:14px;
  }
  .message-item-content{
      width: 360px;
      border: 1px solid #ebebeb;
      border-radius: 3px;
      transition: .2s;
      background: #f5f7fa;
      border-color: #e4e7ed;
      color: #c0c4cc;
      cursor: not-allowed;
  }
  .span-line{
      color:rgb(19, 206, 102);
  }
  .span-line:hover{
      text-decoration:underline;
  }
</style>



// WEBPACK FOOTER //
// src/components/UrgeMessage/UrgeMessage.vue